module.exports = __webpack_public_path__ + "fonts/Lyon Arabic Display Light.b049cf4.otf";